import {
  FABRIC,
  STYLEACCENT,
  STYLEOPTIONS,
  DASHBOARD,
  PENDINGTRANSACTION,
  CONFIRMEDTRANSACTION,
  CANCELEDTRANSACTION,
  REFUNDTRANSACTION,
  REPORTDATA,
  USER,
  ADMINISTRATOR,
  PRODUCTCATEGORY,
  PRODUCTLIST,
  SETAPPEARANCE,
  SETFABRICSTYLE
} from "../../routes/routes_name";
import IconFabrics from "../../assets/icons/icon_fabrics.svg";
import IconSetting from "../../assets/icons/icon_settings.svg";
import IconReport from "../../assets/icons/report_logo.svg";
import IconDashboard from "../../assets/icons/icon_dashboard.svg";
import IconTransaction from "../../assets/icons/icon_transaction.svg";

const menus = [
  {
    title: "Dashboard",
    path: DASHBOARD,
    icon: IconDashboard,
    isOpen: false,
    feature: "dashboard",
  },
  {
    title: "Fabrics",
    path: FABRIC,
    icon: IconFabrics,
    isOpen: false,
    feature: "fabrics",
  },
  {
    title: "Style & Accent",
    path: STYLEACCENT,
    icon: IconSetting,
    isOpen: false,
    feature: "style_accents",
  },
  {
    title: "Style Options",
    path: STYLEOPTIONS,
    icon: IconSetting,
    isOpen: false,
    feature: "style_options",
  },
  {
    title: "Master",
    path: USER,
    icon: IconTransaction,
    isOpen: false,
    feature: "master",
    subMenus: [
      {
        title: "Administrator",
        path: ADMINISTRATOR,
        icon: IconTransaction,
        feature: "master.administrator",
      },
      {
        title: "User",
        path: USER,
        icon: IconTransaction,
        feature: "master.user",
      },
      {
        title: "Product Category",
        path: PRODUCTCATEGORY,
        icon: IconTransaction,
        feature: "master.product_category",
      },
      {
        title: "Product List",
        path: PRODUCTLIST,
        icon: IconTransaction,
        feature: "master.product_list",
      }
    ],
  },
  {
    title: "Transaction",
    path: PENDINGTRANSACTION,
    icon: IconTransaction,
    isOpen: false,
    feature: "transactions",
    subMenus: [
      {
        title: "Pending Transaction",
        path: PENDINGTRANSACTION,
        icon: IconTransaction,
        feature: "transactions",
      },
      {
        title: "Confirmed Transaction",
        path: CONFIRMEDTRANSACTION,
        icon: IconTransaction,
        feature: "transactions",
      },
      {
        title: "Canceled Transaction",
        path: CANCELEDTRANSACTION,
        icon: IconTransaction,
        feature: "transactions",
      },
      {
        title: "Refund List",
        path: REFUNDTRANSACTION,
        icon: IconTransaction,
        feature: "transactions",
      },
    ],
  },
  {
    title: "Report",
    path: REPORTDATA,
    icon: IconReport,
    feature: "report",
  },
   {
    title: "Settings",
    path: SETAPPEARANCE,
    icon: IconSetting,
    isOpen: false,
    feature: "settings",
    subMenus: [
      {
        title: "Appearance",
        path: SETAPPEARANCE,
        feature: "settings.appearance",
      },
      {
        title: "Fabric Style",
        path: SETFABRICSTYLE,
        feature: "settings.fabricstyle",
      },
    ],
  },
];

export default menus;
